/* eslint @typescript-eslint/camelcase: "off" */

import { actionCreatorFactory } from 'typescript-fsa';
import { asyncFactory } from 'typescript-fsa-redux-thunk';

import { getPlatform } from '@utils';

import { Api } from '@api';

import { IState } from '@interfaces';

import {
	ISubscriptionsActionFetchPresentationAvailableCarouselPayload,
	ISubscriptionsActionFetchPresentationAvailableCarouselPayloadDone,
	ISubscriptionsActionFetchPresentationAvailableCarouselPayloadError,
	ISubscriptionsActionPresentationAvailableCarouselSetSelectedIndexPayload,
	ISubscriptionsActionFetchPresentationOrderDetailsPayload,
	ISubscriptionsActionFetchPresentationOrderDetailsPayloadDone,
	ISubscriptionsActionFetchPresentationOrderDetailsPayloadError,
	ISubscriptionsActionSendCodePayload,
	ISubscriptionsActionSendCodePayloadDone,
	ISubscriptionsActionSendCodePayloadError,
	ISubscriptionsActionCreatePayload,
	ISubscriptionsActionCreatePayloadDone,
	ISubscriptionsActionCreatePayloadError,
	ISubscriptionsActionAvailableServisesPayload,
	ISubscriptionsActionAvailableServisesPayloadDone,
	ISubscriptionsActionAvailableServisesPayloadError,
} from './types';

const actionCreator = actionCreatorFactory('Subscriptions');
const actionCreatorAsync = asyncFactory<IState>(actionCreator);

export const subscriptionsFetchPresentationAvailableCarousel = actionCreatorAsync<
	ISubscriptionsActionFetchPresentationAvailableCarouselPayload,
	ISubscriptionsActionFetchPresentationAvailableCarouselPayloadDone,
	ISubscriptionsActionFetchPresentationAvailableCarouselPayloadError
>(
	'fetchPresentationAvailableCarousel',
	async (params?: ISubscriptionsActionFetchPresentationAvailableCarouselPayload) => {
		const clientPlatform = params.clientPlatform || getPlatform();

		const response = await Api.subscriptions.fetchPresentationAvailableCarousel({
			client_platform: clientPlatform,
			mobile_operator_name: params?.mobileOperatorName,
			mobile_operator_mnc: params?.mobileOperatorMnc,
			deeplink_name: params?.deeplinkName,
			pkg_name: params?.pkgName,
		});

		return {
			list: response.data.data,
		};
	},
);

export const subscriptionsPresentationAvailableCarouselSetSelectedIndex = actionCreator<
	ISubscriptionsActionPresentationAvailableCarouselSetSelectedIndexPayload
>('subscriptionsPresentationAvailableCarouselSetSelectedIndex');

export const subscriptionsFetchPresentationOrderDetails = actionCreatorAsync<
	ISubscriptionsActionFetchPresentationOrderDetailsPayload,
	ISubscriptionsActionFetchPresentationOrderDetailsPayloadDone,
	ISubscriptionsActionFetchPresentationOrderDetailsPayloadError
>(
	'subscriptionsFetchPresentationOrderDetails',
	async (params: ISubscriptionsActionFetchPresentationOrderDetailsPayload) => {
		const { apiId, pkgName } = params;

		const response = await Api.subscriptions.fetchPresentationOrderDetails({
			api_id: apiId,
			pkg_name: pkgName,
		});

		return { orderDetails: response.data.data };
	},
);

export const subscriptionsSendCode = actionCreatorAsync<
	ISubscriptionsActionSendCodePayload,
	ISubscriptionsActionSendCodePayloadDone,
	ISubscriptionsActionSendCodePayloadError
>(
	'subscriptionsSendCode',
	async (params: ISubscriptionsActionSendCodePayload) => {
		const {
			provider,
			msisdn,
			serviceId,
			megafonServiceId,
		} = params;

		const response = await Api.subscriptions.sendCode(provider, {
			msisdn,
			service_id: serviceId,
			...(megafonServiceId ? { megafon_service_id: megafonServiceId } : {}),
		});

		return {
			service: response.data.data,
		};
	},
);

export const subscriptionsCreate = actionCreatorAsync<
	ISubscriptionsActionCreatePayload,
	ISubscriptionsActionCreatePayloadDone,
	ISubscriptionsActionCreatePayloadError
>(
	'subscriptionsCreate',
	async (params: ISubscriptionsActionCreatePayload) => {
		const {
			provider,
			msisdn,
			megafonServiceId,
			serviceId,
			verificationCode,
		} = params;

		const response = await Api.subscriptions.create(provider, {
			msisdn,
			...(megafonServiceId ? { megafon_service_id: megafonServiceId } : {}),
			platform: getPlatform(),
			service_id: serviceId,
			verification_code: verificationCode,
		});

		return {
			registration: response.data.data,
			verificationCode: verificationCode,
		};
	},
);

export const subscriptionsAvailableServices = actionCreatorAsync<
	ISubscriptionsActionAvailableServisesPayload,
	ISubscriptionsActionAvailableServisesPayloadDone,
	ISubscriptionsActionAvailableServisesPayloadError
>(
	'subscriptionsAvailableServices',
	async (params: ISubscriptionsActionSendCodePayload) => {
		const {
			provider,
			msisdn,
		} = params;

		const response = await Api.subscriptions.fetchProviderAvailableServices(provider, {
			msisdn,
		});

		return { service: response.data.data };
	},
);
